var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        label: "CPF",
        "label-for": "cpf",
        description: "Digite o CPF no formato XXX.XXX.XXX-XX"
      }
    },
    [
      _c("b-form-input", {
        attrs: {
          id: "cpf",
          type: "text",
          placeholder: "XXX.XXX.XXX-XX",
          required: "",
          state: _vm.cpfState,
          "aria-describedby": "cpf-feedback",
          maxlength: 14
        },
        on: { blur: _vm.validateCpf },
        model: {
          value: _vm.formattedCpf,
          callback: function($$v) {
            _vm.formattedCpf = $$v
          },
          expression: "formattedCpf"
        }
      }),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { id: "cpf-feedback" } }, [
        _vm._v("\n    Por favor, insira um CPF válido.\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }